import { MutationTree } from "vuex";
import { BeruMutations, BeruState } from '@/store/beru/types';

import { parse, format } from 'date-fns';
import { ru } from 'date-fns/locale';

const mutations: MutationTree<BeruState> & BeruMutations = {
    setBeruRates(state, payload) {
        state.beru_rates = Object.entries(payload).map(([dateStr, rates]) => {
            const date = parse(dateStr, 'dd.MM.yyyy', new Date())
            const month = format(date, 'LLLL yyyy', { locale: ru })
            return {
                month: month.charAt(0).toUpperCase() + month.slice(1),
                shiftCost: rates.shiftCost,
                mainShiftCost: rates.mainShiftCost,
                shiftCostRD: rates.shiftCostRD,
            }
        })
    },
    clearBeruRates(state) {
        state.beru_rates = null
    },
    setBeruExchangeFree(state, payload) {
        state.exchange_free = payload;
    },
    appendBeruExchangeFree(state, payload) {
        state.exchange_free = [...(state.exchange_free ?? []), ...payload];
    },
    setBeruExchangeFreeMeta(state, payload) {
        state.exchange_free_meta = payload;
    },
    setBeruExchangeTaken(state, payload) {
        state.exchange_taken = payload;
    },
    appendBeruExchangeTaken(state, payload) {
        state.exchange_taken = [...(state.exchange_taken ?? []), ...payload];
    },
    setBeruExchangeTakenMeta(state, payload) {
        state.exchange_taken_meta = payload;
    },
    setCloseReasons(state, payload) {
        state.close_reasons = payload;
    },
    setCloseTypeReasons(state, payload) {
        state.close_type_reasons = payload;
    },
    setBeruDetail(state, payload) {
        state.beru_detail = payload;
    }
}

export default mutations